/**
 * Servicio API para reportes y templates
 */

import { ReportTemplate, ReportConfig } from '../types/reportConfig';

// URL base de la API - Usa variable de entorno o fallback a producción
const API_BASE_URL = import.meta.env.VITE_BACKEND_API_URL || 'https://control.seprovinsa.com/backend/api';

/**
 * Templates API
 */
export const templatesApi = {
  // Listar todos los templates
  async list(): Promise<ReportTemplate[]> {
    const response = await fetch(`${API_BASE_URL}/templates/list.php`);
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al obtener templates');
    }
    
    return data.data;
  },

  // Crear nuevo template
  async create(template: Omit<ReportTemplate, 'id' | 'createdAt'>): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/templates/create.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(template),
    });
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al crear template');
    }
    
    return data.data.id;
  },

  // Actualizar template existente
  async update(template: ReportTemplate): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/templates/update.php`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(template),
    });
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al actualizar template');
    }
  },

  // Eliminar template
  async delete(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/templates/delete.php?id=${id}`, {
      method: 'DELETE',
    });
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al eliminar template');
    }
  },
};

/**
 * Report Configs API
 */
export const reportConfigsApi = {
  // Listar todas las configuraciones
  async list(): Promise<ReportConfig[]> {
    const response = await fetch(`${API_BASE_URL}/report-configs/list.php`);
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al obtener configuraciones');
    }
    
    return data.data;
  },

  // Crear nueva configuración
  async create(config: Omit<ReportConfig, 'id' | 'createdAt' | 'lastSent'>): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/report-configs/create.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(config),
    });
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al crear configuración');
    }
    
    return data.data.id;
  },

  // Activar/Desactivar configuración
  async toggleActive(id: string): Promise<boolean> {
    const response = await fetch(`${API_BASE_URL}/report-configs/toggle-active.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    });
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Error al cambiar estado');
    }
    
    return data.data.active;
  },
};
